import styled from '@emotion/styled';
import MEDIA_QUERY, { SCREEN_MASSIVE } from '@zola/zola-ui/src/styles/emotion/mediaQuery';

export const ActionContainer = styled.div<{ isPostAuthNav3: boolean }>`
  position: fixed;
  bottom: 16px;
  z-index: 10;
  transform: translateX(-50%);
  left: 50%;

  ${(props) =>
    props.isPostAuthNav3 &&
    `
    ${MEDIA_QUERY.DESKTOP} {
      /* Compensate for the presence of the vertical nav (74px wide) */
      margin-left: ${74 / 2}px;
    }
    ${MEDIA_QUERY.DESKTOP_MASSIVE} {
      /* Page width is limited to 1920px */
      left: ${SCREEN_MASSIVE / 2}px;
    }
  `}
`;
